import { createStore } from 'vuex'

import { Buffer } from 'buffer'

export default createStore({
    state: {
        quizes: null
    },
    mutations: {
        updateQuizes(state) {
            let data = localStorage.getItem("quizes")

            state.quizes = data !== null ? JSON.parse(Buffer.from(data, 'hex').toString()) : null
        },
        setQuizes(state, data) {
            if (data !== undefined && data !== null) {
                let buff = Buffer.from(JSON.stringify(data))
                localStorage.setItem("quizes", buff.toString("hex"))
                state.quizes = data
            }
        }
    },
    actions: {},
    modules: {}
})